import React from 'react'

export default function ChatIndicatorListItemView({
  onListItemClick,
  listItemTitle,
  unreadMessageCount,
  getFormattedUnreadMessageCount
}) {
  return (
    <button
    type="button"
    className="dropdown-item chat-indicator-dropdown-item"
    onClick={onListItemClick}
>
    <span className="w-80 text-truncate chat-title">
        {listItemTitle} 
    </span>
    {unreadMessageCount > 0 && (
        <span 
            className={`chat-indicator-unread d-flex align-items-center justify-content-center w-80 text-truncate`}
        >
            {unreadMessageCount > 0 ? `${getFormattedUnreadMessageCount()}` : ""}
        </span>
    )}
</button>
  )
}
